<template>
    <div>
        <CompetencesEmpty v-if="!getSoftCompetences.length" competences-type="soft"/>
        <template v-else>
            <SoftCompetences
                class="content"
                :levels="displayLevel"
                :items="getSoftCompetences"
            />
            <div class="info-row">
                <span class="info-text">Пройдите </span>
                <a href="#" class="info-link">тестирование</a>
                <span class="info-text">, что бы оценить свои компетенции</span>
            </div>
            <div class="legend-row">
                <div class="legend-item">
                    <div class="legend-bullet-icon"></div>
                    <div class="legend-label">Исходный уровень</div>
                </div>
                <div class="legend-item">
                    <div class="legend-flag-icon"></div>
                    <div class="legend-label">Целевой уровень</div>
                </div>
                <div class="legend-item">
                    <div class="legend-check-icon"></div>
                    <div class="legend-label">Цель достигнута</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import SoftCompetences from "./SoftCompetences";
import CompetencesEmpty from "../CompetencesEmpty";
import { mapGetters } from 'vuex';

const trackGetters = [
    'getSoftCompetences',
    'getCompetenceLevels',
];

export default {
    name: "SoftCompetencesWrapper",

    components: {
        SoftCompetences,
        CompetencesEmpty,
    },

    computed: {
        ...mapGetters('accountTrack', trackGetters),

        displayLevel() {
            return [...this.getCompetenceLevels].reverse();
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    margin-bottom: 20px;
}

.info {
    &-row {
        margin-bottom: 16px;
    }

    &-text, &-link {
        font-size: 14px;
        line-height: 20px;
        color: #2A2626;
    }

    &-link {
        color: #4663AB;
    }
}

.legend {
    &-row {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
    }

    &-item {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin: 0 24px 16px 0;

        &:last-of-type {
            margin: 0 0 16px 0;
        }
    }

    &-label {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #98A0A9;
    }

    &-bullet-icon, &-flag-icon, &-check-icon {
        width: 22px;
        height: 22px;
        margin-right: 6px;
        background: no-repeat center/cover;
    }

    &-bullet-icon {
        background-image: url("~@/assets/images/account-track/icon/competences/competence-empty-simple.svg");
    }

    &-flag-icon {
        background-image: url("~@/assets/images/account-track/icon/competences/flag.svg");
    }

    &-check-icon {
        background-image: url("~@/assets/images/account-track/icon/competences/competence-complete-simple.svg");
    }
}
</style>